import { KoButton } from 'packages';
import KoIcon from '@kwapio/icons';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './apiplatform.module.scss';

const TABS = [
  { key: 'services', label: 'Services', icon: 'AppstoreOutlined' },
  { key: 'endpoints', label: 'Endpoints', icon: 'ApiOutlined' },
  { key: 'explorer', label: 'Explorer', icon: 'SendOutlined' },
  { key: 'collections', label: 'Collections', icon: 'FolderOutlined' },
  { key: 'environments', label: 'Environments', icon: 'CloudOutlined' },
  { key: 'contract-diff', label: 'Contract Diff', icon: 'DiffOutlined' },
  { key: 'release-tests', label: 'Release Tests', icon: 'ExperimentOutlined' },
  { key: 'audit-logs', label: 'Audit Logs', icon: 'AuditOutlined' }
];

function ApiSubNav({ activeKey }) {
  const { workspaceId } = useParams();
  const navigate = useNavigate();

  const basePath = workspaceId
    ? `/workspace/${workspaceId}/development/apiplatform`
    : '/apiplatform';

  return (
    <div className={styles.subNav}>
      {TABS.map((tab) => (
        <KoButton
          key={tab.key}
          type={activeKey === tab.key ? 'primary' : 'text'}
          label={tab.label}
          icon={<KoIcon name={tab.icon} width={14} height={14} />}
          onClick={() => navigate(tab.key === 'services' ? basePath : `${basePath}/${tab.key}`)}
          className={styles.subNavBtn}
        />
      ))}
    </div>
  );
}

export default ApiSubNav;
